var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SelectUser,{attrs:{"isRadio":_setup.selectOptions.isRadio,"isNeedSearch":_setup.selectOptions.isNeedSearch,"title":_setup.selectOptions.title,"userList":_setup.userList},on:{"search":_setup.handleSearch,"complete":_setup.handleSelectedResult}})
}
var staticRenderFns = []

export { render, staticRenderFns }